module.exports = __webpack_public_path__ + "static/media/card-icon-background.b64c411e.svg";